/* Ana sayfa «Ürünlerimizi Keşfedin» — CSS Grid + filtre (Isotope grid-sizer kaldırıldı) */
(function ($) {
  var MOBILE_TAB_MQ = window.matchMedia('(max-width: 767.98px)');

  function isMobileTabMode() {
    return MOBILE_TAB_MQ.matches;
  }

  function bindHomeGridFilters() {
    var $grid = $('#bioniksHomeProductGrid');
    if (!$grid.length) return;

    var $section = $grid.closest('section');
    var $filters = $section.find('.bioniks-home-grid-filters, .filters');
    if (!$filters.length) return;

    // custom.js window.load → masonryBox() sonrası isotope handler'ını kaldır
    $filters.off('click', 'li');
    $filters.off('click.bioniksHomeGrid');
    $filters.find('li').off('click');

    function applyFilter(filter) {
      $grid.find('.grid-item').each(function () {
        var $item = $(this);
        var show = filter === '*' || $item.is(filter);
        $item.toggleClass('bioniks-home-product-grid__item--hidden', !show);
      });
    }

    $filters.on('click.bioniksHomeGrid', 'li[data-filter]', function (e) {
      var $li = $(this);
      var collectionUrl = $li.attr('data-collection-url');

      if (isMobileTabMode() && collectionUrl) {
        e.preventDefault();
        window.location.assign(collectionUrl);
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      $filters.find('li').removeClass('active');
      $li.addClass('active');
      applyFilter($li.attr('data-filter') || '*');
    });
  }

  if (document.readyState === 'complete') {
    bindHomeGridFilters();
  } else {
    $(window).on('load', bindHomeGridFilters);
  }

  $(document).on('bioniks:sections-refreshed', bindHomeGridFilters);
})(jQuery);
